import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import ProClientIcon from '../ProClientIcon';

const ProClientBadge = () => (
    <div className="flex flex-row flex-items-center">
        <ProClientIcon className="m-r-4" />
        <span className="tbody-6 co-grey-1000 text-semi-bold m-t-2">{translate('reviews.pro_client')}</span>
    </div>
);

export default ProClientBadge;
